import styled from "styled-components/macro";

export const NewHomepageContainer = styled.div`
  background-color: #f5f2e4;
  overflow-x: hidden;
  display: block;
  min-height: 100%;
  position: relative;
  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.1);
  nav {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    #logo {
      padding: 24px;
      width: 80px;
      opacity: 0.5;
    }
    ul {
      list-style-type: none;

      li {
        display: inline-block;
        font-family: "Inter";
        font-weight: 500;
        padding: 24px 5px 24px 24px;

        &:last-child {
          padding-right: 36px;
        }

        a {
          color: #2b2315;
          opacity: 0.5;
        }
      }
    }
  }
  h1 {
    font-family: "GT Super Text";
    font-weight: 600;
    font-size: 54px;
    margin: 0;
    word-spacing: -0.1rem;
    transition: font-size 300ms ease-in-out;
  }
  h2 {
    font-size: 42px;
    font-family: "GT Super Text";
    font-weight: 600;
    line-height: 110%;
    transition: font-size 300ms ease-in-out;
  }
  h3 {
    font-family: "GT Super Text";
    font-weight: 600;
    font-size: 24px;
    line-height: 130%;
  }
  a {
    color: inherit;
  }
  h1,
  h2,
  h3,
  p,
  a {
    z-index: 2;
  }
  button {
    border-radius: 10px;
    font-size: 18px;
    padding: 16px 24px;
    outline: 0;
    border: 0;
    text-decoration: none;
    cursor: pointer;
    font-family: "Inter";
    font-weight: 500;
    transition: font-size 200ms;
  }
  section {
    display: flex;
    flex-direction: column;
  }

  .blur {
    position: absolute;
    width: 1000px;
    max-width: 70vw;
    z-index: 0;
    left: 0px;
  }

  .content-row {
    display: flex;
    flex-direction: row;
    max-width: 1200px;
    margin: auto;
    align-items: center;
    h2 {
      max-width: 600px;
      text-align: left;
    }
    transition: max-width 200ms;
  }

  #hero-module {
    .shrink-on-short-viewports {
      max-height: 6vh;
    }
    h1 {
      font-weight: 400;
      max-width: 90vw;
      text-align: center;
      margin: auto;
      font-size: 4vw;
      transition: font-size 300ms ease-in-out, line-height 300ms ease-in-out;
      i {
        font-style: italic;
      }
      .orange {
        color: #ee8f00;
      }
      .red {
        color: #ea4713;
      }
      .purple {
        color: #db27df;
      }
      .rainbow1 {
        color: #17abcc;
      }
      .rainbow2 {
        color: #18c6a6;
      }
      .rainbow3 {
        color: #17d06c;
      }
      .rainbow4 {
        color: #52cb19;
      }
      .rainbow5 {
        color: #6acc09;
      }
      .smallcaps {
        font-variant: small-caps;
      }
    }
    .content-row {
      justify-content: space-around;
      .content-column {
        max-width: 90vw;
        align-items: center;
      }
    }
  }

  #logo-module {
    img {
      max-height: 28px;
      width: auto;
      margin: 10px 0px;
      mix-blend-mode: multiply;
      opacity: 0.45;
    }
    .logos {
      display: flex;
      gap: 2vw;
      transition: gap 300ms ease-in-out;
      flex-wrap: wrap;
      justify-content: space-evenly;
    }
    .as-seen-in {
      font-family: Inter;
      font-size: 7px;
      font-weight: 700;
      line-height: 8px;
      letter-spacing: 0.5vw;
      margin-right: -0.5vw; //cancels out last-letter letterspacing
      text-align: center;
      color: #000;
      opacity: 0.45;
    }
    .content-row {
      flex-direction: row;
      justify-content: space-evenly;
      align-items: center;
      align-content: center;
      /* max-width: 900px; */
      margin: auto;
      width: 100vw;
    }
    background: transparent;
    margin-top: -120px;
    transition: margin-top 300ms ease-in-out;
  }

  #product-module,
  #ai-101 {
    video {
      border-radius: 42px;
      box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1);
      transition: max-width 300ms ease-in-out;
    }
    .jumbo-header {
      font-size: 64px;
      font-weight: 400;
      text-align: center;
      max-width: 100%;
    }
  }

  #product-module {
    h2 {
      font-weight: 400;
      max-width: 450px;
      margin: auto;
    }
    video {
      transition: max-width 300ms ease-in-out;
      width: 700px;
      max-width: 60vw;
      border-radius: 15px;
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1), 0px 4px 10px rgba(0, 0, 0, 0.15);
    }
    .feel-like-home {
      .content-column {
        max-width: 300px;
      }
      img {
        height: 200px;
        width: 300px;
        background-position: center center;
        margin: auto;
        margin-bottom: 10px;
        border-radius: 8px;
        box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3), 0px 4px 10px rgba(0, 0, 0, 0.45);
      }
      p {
        text-align: center;
        line-height: 130%;
        font-weight: 500;
      }
    }
    .content-row {
      justify-content: space-between;
      width: 90vw;
      .feature-header {
        font-size: 32px;
        font-weight: 400;
        margin: 0px;
        margin-bottom: 14px;
        line-height: 120%;
      }
      .feature-body {
        font-family: Inter;
        font-size: 20px;
        line-height: 130%;
        text-align: left;
      }
      .feature-header,
      .feature-body {
        max-width: 400px;
      }
      .thinner {
        max-width: 345px;
      }
      .wider {
        max-width: 510px;
      }
      .slightly-wider {
        max-width: 420px; //🌿
      }
      #brainstorm-buddy {
        max-width: 460px;
      }
    }
  }

  #ai-101 {
    .header-section {
      margin: auto;
    }
    img {
      max-height: 80vh;
      max-width: 400px;
    }

    video {
      max-height: 80vh;
      max-width: 600px;
    }
    h2 {
      margin: auto;
    }
    h3 {
      max-width: 600px;
      margin: auto;
      font-size: 24px;
      font-weight: 400;
      margin-top: 10px;
    }
    .body {
      font-family: "Inter";
      text-align: left;
      max-width: 400px;
      font-size: 18px;
      line-height: 130%;
      a {
        text-decoration: underline;
      }
    }
  }

  #extension {
    h2 {
      font-weight: 400;
      font-size: 32px;
      width: 40vw;
      transition: width 300ms ease-in-out;
    }
    img {
      margin-left: 10vw;
      max-width: 40vw;
      transition: max-width 300ms ease-in-out;
    }
    button {
      background-color: #27ae60;
      color: #fff;
    }
  }

  #testimonials-module {
    .quote {
      transition: margin-bottom 200ms;
      font-family: "GT Super Text";
      font-weight: 300;
      font-style: italic;
      line-height: 130%;
      max-width: 448px;
      font-size: 28px;
      text-align: left;
      background-color: #fff;
      padding: 24px;
      border-radius: 24px;
      position: absolute;
      .caption-column {
        display: flex;
        flex-direction: column;
        position: absolute;
        p {
          font-style: normal;
        }
        img {
          width: 200px;
        }
        .caption {
          font-family: "GT Super Text";
          opacity: 0.5;
          font-size: 18px;
        }
      }
    }
    .quote-mini {
      font-family: "GT Super Text";
      font-weight: 300;
      font-style: italic;
      max-width: 150px;
      font-size: 18px;
      text-align: left;
      background-color: #fff;
      padding: 14px;
      border-radius: 12px;
      position: absolute;
    }
    .speech-bubble-point {
      position: absolute;
      bottom: -36px;
    }
    .quote-canvas {
      width: 100vw;
      max-width: 1000px;
      height: 650px;
      position: relative;
      margin: auto;

      #nyt-quote {
        width: 418px;
        left: 15%;
      }
      #nyt-caption {
        bottom: -80px;
        left: 22%;
      }
      #nyt-bubble-point {
        left: 28px;
      }
      #washpo-quote {
        width: 412px;
        right: 2.5%;
        top: 35%;
      }
      #washpo-caption {
        left: 5%;
        bottom: -80px;
      }
      #washpo-bubble-point {
        left: 244px;
        -webkit-transform: scaleX(-1);
        transform: scaleX(-1);
      }
      #new-yorker-quote {
        width: 390px;
        bottom: 15%;
        left: 2.5%;
      }
      #new-yorker-caption {
        bottom: -80px;
        left: 27%;
      }
      #new-yorker-bubble-point {
        left: 42px;
      }
    }
    .quote-canvas-authors {
      width: 100vw;
      max-width: 1120px;
      height: 300px;
      position: relative;
      text-align: center;

      .content-column {
        align-items: center;
        position: relative;
        width: 190px;
        .author-name {
          font-family: "Inter";
          font-weight: 600;
          line-height: 160%;
          font-size: 20px;
          font-family: "GT Super Text";
        }
        .author-bio {
          font-family: "Inter";
          opacity: 0.55;
          line-height: 130%;
          font-weight: 500;
          font-family: "GT Super Text";
        }
        .portrait {
          height: 160px;
          border-radius: 16px;
        }
      }

      #John-quote {
        bottom: 200px;
        left: -130px;
      }
      #John-bubble-point {
        width: 50px;
        left: 124px;
      }
      #Hugh-quote {
        bottom: 244px;
        left: -20px;
      }
      #Hugh-bubble-point {
        left: 22px;
        bottom: -43px;
      }
      #April-quote {
        bottom: 175px;
        left: 150px;
        width: 130px;
      }
      #Mark-bubble-point {
        left: 0px;
        -webkit-transform: scaleX(-1);
        transform: scaleX(-1);
      }
      .content-row {
        position: absolute;
        left: 50%;
        bottom: 0%;
        transform: translateX(-50%);
      }
    }
    #author-header {
      max-width: 90vw;
      width: 380px;
    }
  }

  #cta-module {
    #hero-2 {
      width: 50vw;
      z-index: 1;
    }
    #cta-button-lockup {
      margin: 0;
      max-width: 540px;
    }
    .content-row {
      justify-content: space-between;
      p {
        text-align: left;
        font-weight: 500;
        opacity: 0.7;
      }
    }
    .content-column {
      z-index: 10;
      .trial-copy {
        width: 45vw;
        max-width: 500px;
      }
      .disclaimer {
        font-family: "Inter";
        max-width: 260px;
        text-align: left;
        opacity: 0.5;
        line-height: 120%;
      }
    }
  }

  #manifesto-module {
    z-index: 10;
    a {
      text-decoration: underline;
      text-decoration-thickness: from-font;
      text-underline-offset: 0.5px;
    }
    .manifesto-header {
      width: 27vw;
      max-width: 300px;
      text-align: right;
    }
    .content-row {
      align-items: baseline;
      #origin-story {
        font-family: "GT Super Text";
        font-weight: 300;
        line-height: 130%;
        width: 57%;
        max-width: 500px;
        text-align: left;
        font-size: 20px;
      }
    }
  }

  #footer-module {
    margin-bottom: 1vw;
    .content-row {
      align-items: flex-start;
      .footer-header {
        font-family: "Inter";
        line-height: 130%;
        font-weight: 600;
        width: 115px;
        text-align: left;
      }
      .footer-item {
        /* cursor: pointer; */
        font-family: "Inter";
        line-height: 130%;
        font-weight: 500;
        opacity: 0.5;
      }
    }
  }

  .wide {
    max-width: 100%;
    margin: 0;
    justify-content: space-between;
  }

  .use-space-between {
    justify-content: space-between;
  }

  .content-column {
    display: flex;
    z-index: 20;
    flex-direction: column;
    align-items: flex-start;
    max-width: 600px;
  }

  .light {
    position: relative;
    /* background: #f5f2e4; */
    color: #413520;
  }
  .paper-texture {
    background: url("/assets/paper-texture.jpg");
    background-size: 1000px;
    position: absolute;
    width: 100%;
    min-height: 100%;
    opacity: 20%;
    z-index: 0;
  }
  .green-upper-button {
    position: relative;
    z-index: 1;
    background-color: #27ae60;
    color: #fff;
    box-shadow: 0px 0px 30px rgba(0, 255, 163, 0.7);
  }
  .green-lower-button {
    white-space: nowrap;
    position: relative;
    z-index: 1;
    background-color: #27ae60;
    color: #fff;
    box-shadow: 0px 0px 15px rgba(0, 255, 163, 0.5);
  }
  .green-corner-button {
    position: fixed;
    z-index: 100;
    background-color: #27ae60;
    color: #fff;
    box-shadow: 0px 0px 15px rgba(0, 255, 163, 0.5);
    bottom: 27px;
    right: 50px;
    opacity: 0;
    transition: right 500ms ease-in-out, opacity 300ms ease-in-out;
  }
  .show-corner-button {
    right: 100px;
    opacity: 1;
  }
  .dark {
    .paper-texture {
      opacity: 0.05;
    }
    border-radius: 2vw;
    transition: margin 300ms ease-in-out;
    margin: 0vw 1vw;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
    position: relative;
    background-color: #2b2315;
    background-size: 1000px;
    color: #f5f1d3;
    z-index: 1;
    button {
      font-weight: 500;
    }
    .logo {
      opacity: 1;
    }
  }
  .yellow {
    background-color: #ffeeb1;
    color: #261b04;
  }

  .spacer-xl,
  .spacer-lg,
  .spacer,
  .spacer-medium,
  .spacer-small,
  .spacer-smaller,
  .spacer-smallest {
    display: block;
    transition: width 300ms ease-in-out, height 300ms ease-in-out;
  }
  .spacer-xl {
    height: 125px;
    width: 125px;
    display: block;
  }
  .spacer-lg {
    height: 100px;
    width: 100px;
    display: block;
  }
  .spacer {
    height: 75px;
    width: 75px;
    display: block;
  }
  .spacer-medium {
    height: 50px;
    width: 50px;
    display: block;
  }
  .spacer-small {
    height: 32px;
    width: 32px;
  }
  .spacer-smaller {
    height: 20px;
    width: 20px;
  }
  .spacer-smallest {
    height: 8px;
    width: 8px;
  }

  @media (max-height: 700px) {
    #hero-module {
      .shrink-on-short-viewports {
        max-height: 2vh;
      }
    }
  }

  @media (max-width: 1500px) {
    #logo-module {
      .content-row {
        .logos {
          gap: 0px 40px;
          justify-content: center;
        }
        .as-seen-in {
          display: none;
        }
      }
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: space-evenly;
      align-items: center;
      align-content: center;
      width: 95vw;
      margin: auto;
      margin-top: -120px;
    }
  }

  @media (max-width: 1200px) {
    button {
      border-radius: 8px;
      font-size: 18px;
      padding: 12px 18px;
    }
    #blur,
    #blur-2 {
      width: 70vw;
    }
    h1 {
      word-spacing: 0rem;
    }
    h2 {
      font-size: 4vw;
      width: 40vw;
    }
    #product-module {
      video {
        max-width: 50vw;
      }
    }
    .jumbo-header {
      width: 92%;
    }
    #testimonials-module {
      h2 {
        width: auto;
      }
    }
    #ai-101 {
      video {
        max-width: 400px;
      }
    }
  }

  @media (max-width: 1100px) {
    .green-corner-button {
      bottom: 31px;
    }

    #product-module {
      .medium-on-tablet {
        width: 50px;
        height: 50px;
      }
      .content-row {
        flex-direction: column;
      }

      .feel-like-home {
        align-items: center;
        justify-content: center;
        .content-column {
          max-width: 450px;
          align-items: center;
          p {
            max-width: 300px;
          }
        }
        img {
          height: auto;
          width: 450px;
        }
      }
      .reverse-order-when-vertical {
        flex-direction: column-reverse;
      }
      video {
        max-width: 90vw;
      }
      .content-row {
        .feature-header {
          text-align: center;
          margin: auto;
          margin-bottom: 14px;
        }
        .wider-on-tablet {
          max-width: 510px;
          width: 510px;
        }
        .tighter-on-tablet {
          max-width: 500px;
          width: 500px;
        }
        .feature-body {
          text-align: center;
          margin: auto;
        }
      }
    }
    #extension {
      .content-row {
        flex-direction: column;
        .content-column {
          align-items: center;
        }
      }
      img {
        margin-left: 0px;
        max-width: 70vw;
      }
      h2 {
        text-align: center;
        width: 70vw;
      }
    }
    #ai-101 {
      .content-row {
        flex-direction: column;
      }
      .reverse-order-when-vertical {
        flex-direction: column-reverse;
      }
      video {
        max-width: 95vw;
      }
    }
  }

  @media (max-width: 960px) {
    .dark {
      margin: 0vw 2vw;
    }
    //tablet
    .green-corner-button {
      bottom: 35px;
    }

    #hero-module {
      .small-header {
        display: block;
      }
      h1 {
        font-size: 7vw;
        line-height: 120%;
      }
    }
    .large-header {
      display: none;
    }
    .jumbo-header {
      font-size: 52px;
    }
    #product-module {
      h1,
      h2,
      h3 {
        max-width: 45vw;
      }
      img {
        max-width: 90vw;
      }
      .content-row {
        max-width: 90vw;
        margin: auto;

        .wider-on-small-tablet {
          max-width: 95vw;
          width: 450px;
        }
      }
    }

    #logo-module {
      img {
        max-height: 24px;
      }
    }

    #testimonials-module {
      h2 {
        width: auto;
      }
      .content-row {
        flex-direction: column;
        width: 90vw;
      }
      #newspaper-quotes {
        margin: 0;
      }
      #author-header {
        max-width: 90vw;
        width: 380px;
      }
      .quote-canvas {
        width: 100vw;
        display: flex;
        flex-direction: column;
        height: auto;
        align-items: center;
        margin: 0;
        #nyt-quote,
        #washpo-quote,
        #new-yorker-quote {
          width: 80vw;
          left: 5vw;
        }

        #nyt-caption,
        #washpo-caption,
        #new-yorker-caption {
          left: 20px;
          align-items: flex-start;
        }
        #washpo-caption {
          right: 10px;
          left: auto;
        }

        #washpo-bubble-point {
          left: 30px;
          transform: scaleX(1);
        }
        #nyt-bubble-point,
        #new-yorker-bubble-point {
          right: 50px;
          left: auto;
          transform: scaleX(-1);
        }
      }
      .quote-canvas-authors {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        height: auto;
        .content-row {
          position: relative;
          width: 100%;
        }
        #John-quote {
          bottom: 197px;
          left: -82px;
          width: 119px;
        }
        #John-bubble-point {
          left: 102px;
          top: 63px;
        }
        #Hugh-quote {
          bottom: 242px;
          left: 117px;
          width: 124px;
        }
        #Hugh-bubble-point {
          transform: scaleX(-1);
          left: 42px;
        }
        #April-quote {
          bottom: 220px;
          left: -88px;
          width: 130px;
        }
        #Mark-bubble-point {
          left: 65px;
          transform: scaleX(1);
        }
      }
      .quote {
        position: relative;
        max-width: 400px;
        margin-bottom: 100px;
      }
      .caption-column {
        position: absolute;
        align-items: flex-start;
        max-width: 300px;
        p {
          text-align: left;
        }
      }
      .quote-canvas-authors {
        width: 100vw;
        display: flex;
        flex-direction: column;
      }
    }
    #cta-module {
      .content-column {
        position: relative;
        .content-row {
          flex-direction: column;
          align-items: flex-start;
          p {
            max-width: 350px;
            line-height: 140%;
          }
        }
      }
    }

    #manifesto-module {
      .content-row {
        flex-direction: column;
        width: 75vw;
        h3 {
          width: 40vw;
        }
        #origin-story {
          width: 90vw;
          max-width: 100%;
        }
        .manifesto-header {
          text-align: left;
          width: 90vw;
        }
      }
    }
    .hide-on-tablet {
      width: 0px;
      height: 0px;
    }
  }

  @media (min-width: 960px) {
    .small-header {
      display: none;
    }
  }

  @media (max-width: 760px) {
    button {
      border-radius: 6px;
      font-size: 14px;
      padding: 10px 14px;
    }
    #extension {
      img {
        max-width: 90vw;
      }
    }
  }

  @media (max-width: 700px) {
    //mobile-lg
    #legal,
    #product {
      display: none;
    }

    .hide-on-mobile-lg {
      width: 0px;
      height: 0px;
    }
  }

  @media (max-width: 500px) {
    .green-upper-button {
      position: sticky;
      top: 0;
    }
    .dark {
      border-radius: 2vh;
    }
    .disappear-on-mobile {
      display: none;
    }
    .green-corner-button {
      bottom: 27px;
    }
    #product-module {
      .jumbo-header {
        font-size: 42px;
        max-width: 90vw;
      }
      .content-row {
        .wider-on-mobile {
          max-width: 90vw; //for fixing widows
        }
        .wider-on-tablet {
          max-width: 90vw;
        }
        .even-wider-on-mobile {
          max-width: 95vw; //for fixing widows
        }
      }
      .dark {
        border-radius: 2vh;
        .content-row {
          padding: 0px 0px;
        }
      }
    }
    .content-row {
      flex-direction: column;
    }
    //mobile
    #hero-module {
      #hero {
        width: 100vw;
      }
      .blur {
        z-index: 1;
        top: -12vw;
        width: 130vw;
        max-width: 130vw;
        opacity: 0.7;
      }
      .content-column {
        z-index: 10;
        align-items: center;
      }
      h1 {
        text-align: center;
      }
      margin-bottom: 30px;
    }
    #logo-module {
      img {
        max-height: 30px;
      }
      margin-top: -60px;
    }
    #ai-101 {
      .body {
        max-width: 90vw;
      }
      h3 {
        max-width: 95vw;
      }
      video {
        max-width: 90vw;
      }
      img {
        max-width: 90vw;
        height: auto;
      }
    }

    #cta-module {
      #hero-2 {
        width: 100vw;
      }
      .blur {
        z-index: 1;
        top: 9vw;
        width: 130vw;
        max-width: 130vw;
      }
    }
    nav {
      z-index: 100;
      a {
        z-index: 100;
      }

      ul {
        z-index: 100;
        li {
          padding-right: 35px;

          &.login {
            display: none;
          }
        }
      }
    }

    h1 {
      font-size: 35px;
      width: 90vw;
    }
    h2 {
      font-size: 35px;
      width: 90vw;
    }

    button {
      border-radius: 6px;
      font-size: 20px;
      padding: 14px 24px;
    }

    .wide {
      max-width: 90%;
      margin: auto;
    }

    .hide-on-mobile {
      width: 0px;
      height: 0px;
    }
    .hide-on-desktop {
      display: block;
    }

    .smaller-on-mobile {
      width: 25px;
      height: 25px;
    }

    .medium-on-mobile {
      width: 50px;
      height: 50px;
    }

    #product-module {
      h2 {
        max-width: 90vw;
      }
      #feedback,
      #brainstorm,
      #rewrite {
        width: 90vw;
        max-width: 90vw;
      }
    }

    #testimonials-module {
      #newspaper-quotes {
        margin: 0;
      }
      .content-row {
        margin: auto;
      }
      h2 {
        text-align: center;
        margin: auto;
      }
    }
    #extension {
      h2 {
        width: 90vw;
      }
    }

    #cta-module {
      .content-column {
        align-items: center;

        .content-row {
          h2,
          p {
            text-align: center;
          }
          p {
            max-width: 70vw;
          }
          .trial-copy {
            width: 90vw;
          }
        }
      }
      #cta-button-lockup {
        align-items: center;
      }
    }

    #manifesto-module {
      .content-row {
        width: 90vw;
      }
    }

    #footer-module {
      #sitemap {
        flex-direction: row;
        flex-wrap: wrap;
        padding-left: 0;
        #product {
          padding-bottom: 24px;
        }
      }
    }
  }
`;
